import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent } from './accordion.component';
import { CollapseModule } from '../collapse/collapse.module';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [AccordionComponent],
  imports: [CommonModule, IconModule, CollapseModule],
  exports: [AccordionComponent],
})
export class AccordionModule {}
